import moment from 'moment';

export const applyDelay = (exactDeliveryTime: string, delayInMinutes: number) => {
  const exactDeliveryTimeMoment = moment(exactDeliveryTime, 'HH:mm');

  return exactDeliveryTimeMoment.add(delayInMinutes, 'minute').format('HH:mm');
};
